import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getContent } from 'app/modules/cms/service/store/cms-selectors';
import { CmsPageContentType } from 'app/modules/cms/tools/types';
import { getDocumentPathFromOfferSku } from 'app/shared/util/method-util';
import { isNull } from 'lodash';
import React, { useState } from 'react';
import { Translate } from 'react-jhipster';
import { useSelector } from 'react-redux';
import { Collapse, Modal, ModalBody } from 'reactstrap';
import packageJson from '../../../../../../../../package.json';
import './mobile-options.scss';
import moment from 'moment';
import { IRootState } from 'app/shared/reducers';

const MobileOptions = ({ didomi, spbLogoUrl, offerSku, handleOpenDocument, languagesList }) => {

  const REACT_APP_VERSION = packageJson.version.replace('-SNAPSHOT', '');
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const cmsContent = useSelector((state: IRootState) => state.cms.content)[CmsPageContentType.APP_GLOBAL_TYPE]
  const [collapse, setCollapse] = useState(false);
  const toggleCollapse = () => setCollapse(!collapse);

  const documentUrl = useSelector((state: IRootState) => state.config.documentUrl);
  const documentPath = documentUrl ?? getDocumentPathFromOfferSku(offerSku);
  const selectLangue = (language) => {
    localStorage.setItem('language', language);
    window.location.reload();
  }

  return (
    <>
      <div className="mobileOptionsIcon" onClick={() => toggle()}>
        <FontAwesomeIcon icon="ellipsis-v" size="lg" />
      </div>
      <Modal isOpen={modal} toggle={toggle} className="mobileOptionsPanel">
        <ModalBody>
          <div className="text-center">
          <h5 >
            Pour toute question relative à votre demande, vous pouvez contacter l&apos;un de nos conseillers au :
          </h5>

            <p > <strong>09 70 82 03 68</strong> Numéro non surtaxé</p>

          <p>
            Du lundi au vendredi de 8h a 20h et le samedi de 9h30 a 20h hors jours légalement chômés et / ou fériés et sauf interdiction légale ou réglementaire.
          </p>
        <div className="notice-links">
          <ul>
            <li><a onClick={() => handleOpenDocument("https://assurances.spb.eu/documents/LegalNotice.pdf", "Mentions légales")}>
              {cmsContent && cmsContent.legalNotice}
            </a></li>
            <li><a onClick={() => handleOpenDocument("https://assurances.spb.eu/documents/CharteConfidentialite.pdf", "Charte de confidentialité")}>
              {cmsContent && cmsContent.privacyPolicy}
            </a></li>
            <li><a onClick={() => handleOpenDocument("https://assurances.spb.eu/documents/CGU.pdf", "CGU")}>
              {cmsContent && cmsContent.termsOfService}
            </a></li>
            <li><a onClick={() => didomi.preferences.show()} style={{ cursor: 'pointer' }} >
              {cmsContent && cmsContent.cookieManagement}
            </a></li>
            <li onClick={toggleCollapse}>
              <Translate contentKey="form.mobile.burgerMenu.languages.name"></Translate>
              <Collapse isOpen={collapse}>
                <ul className="languageList">
                  {languagesList.map((language, key) => {
                    return <li key={key} onClick={(e) => selectLangue(language.toLowerCase())}>
                      {language}
                      <img className="flags" src={"/content/images/flags/" + language + ".svg"} />
                    </li>
                  })}
                </ul>
              </Collapse>
            </li>
            <div className="footer-version">
              <div >
                Copyright © {moment().format('YYYY')} version : {REACT_APP_VERSION}
              </div>
              {!isNull(spbLogoUrl) && <div> <img height={30} src={"/content/images/SPB-Logo.png"} alt="SPB Logo" /> </div>}
            </div>
          </ul>
          </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
}

export default MobileOptions;
